module.exports = __webpack_public_path__ + "media/images/share-linkedin-244e5ac143a33814a1c75a8a18b048cd.svg";